exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Jbz3{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;background:#fff;margin-bottom:20px;font-weight:400}._1z1-L{cursor:pointer;border-bottom:4px solid transparent;padding:10px 15px;font-size:14px;color:#000;text-decoration:none}._1z1-L._2OPjK,._1z1-L:focus,._1z1-L:hover{border-color:#ffd906}._2GSn3{font-weight:bolder;padding-left:5px;font-size:12px}", ""]);

// exports
exports.locals = {
	"root": "_1Jbz3",
	"link": "_1z1-L",
	"active": "_2OPjK",
	"badge": "_2GSn3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/TabButtons/TabButtons.css
// module id = 2538
// module chunks = 15 17